import {
  ApplicationConfig,
  importProvidersFrom,
  PLATFORM_ID,
  inject,
  provideAppInitializer,
} from '@angular/core';
import {
  PreloadAllModules,
  provideRouter,
  withPreloading,
} from '@angular/router';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { JWT_OPTIONS, JwtModule } from '@auth0/angular-jwt';
import { RdxDialogService } from '@radix-ng/primitives/dialog';

import { routes } from './app.routes';
import { AuthService } from './core/services/auth.service';
import { provideAngularSvgIcon } from 'angular-svg-icon';
import { NgProgressHttpModule } from 'ngx-progressbar/http';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { HttpErrorInterceptor } from './core/intercepters/http-error.interceptor';
import { AuthInterceptor } from './core/intercepters/auth.interceptor';
import { isPlatformBrowser } from '@angular/common';

/**
 * Factory function to initialize the Auth Service
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function initializeAuthService(authService: AuthService): () => Promise<void> {
  return async () => authService.initAuthService();
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function jwtOptionsFactory(platformId: any) {
  return {
    tokenGetter: () => {
      let token = null;
      if (isPlatformBrowser(platformId)) {
        token = localStorage.getItem('token');
      }
      return token;
    },
    // whitelistedDomains: ['localhost:3000'],
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideClientHydration(),
    importProvidersFrom(
      JwtModule.forRoot({
        jwtOptionsProvider: {
          provide: JWT_OPTIONS,
          useFactory: jwtOptionsFactory,
          deps: [PLATFORM_ID],
        },
      }),
      NgProgressHttpModule,
    ),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    provideAnimations(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    // {
    //   provide: NGX_MONACO_EDITOR_CONFIG,
    //   useValue: {
    //     baseUrl: 'assets',
    //     defaultOptions: { scrollBeyondLastLine: false },
    //     onMonacoLoad: () => {
    //       // eslint-disable-next-line @typescript-eslint/no-explicit-any
    //       console.log((window as any).monaco);
    //     },
    //   },
    // },
    AuthService,
    RdxDialogService,
    provideAppInitializer(() => {
      const initializerFn = initializeAuthService(inject(AuthService));
      return initializerFn();
    }),
    // provideToastr({
    //   toastClass: '',
    //   toastComponent: ToastComponent,
    // }),
    provideAngularSvgIcon(),
  ],
};
